import React, {useState} from "react";
import "../css/main.css";
import "../css/dashboard.css";
import AddTourModal from "../components/AddTourModal";
import DashTours from "../components/DashTours";
import {useNavigate} from "react-router-dom";
import UserDashboard from "../components/UserDashboard";
import AdminDashboard from "../components/AdminDashboard";
import UniAdminDashboard from "../components/UniAdminDashboard";
import MultiUserDashboard from "./MultiUserDashboard";
import { isUser, isSuperAdmin, isUniAdmin, isMultiUser } from "../utils/roleUtils";

const Dashboard = () => {
    const navigate = useNavigate();

    // Debug logging
    console.log("Dashboard: Current role from localStorage:", localStorage.getItem("role"));
    console.log("Dashboard: isUser():", isUser());
    console.log("Dashboard: isSuperAdmin():", isSuperAdmin());
    console.log("Dashboard: isUniAdmin():", isUniAdmin());
    console.log("Dashboard: isMultiUser():", isMultiUser());

    return (
        <div>
            {isUser() && (
                <UserDashboard/>
            )}
            {isSuperAdmin() && (
                <AdminDashboard/>
            )}
            {isUniAdmin() && (
                <UniAdminDashboard/>
            )}
            {isMultiUser() && (
                <MultiUserDashboard/>
            )}
        </div>
    );
};

export default Dashboard;